module.exports = __webpack_public_path__ + "img/search-btn.067e2747.png";